function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M250,432.84C95.93,344.93,27.22,268.15,27.22,183.93c0-34.19,10.17-65.08,28.64-87,19.79-23.46,47.92-35.86,81.36-35.86,51.89,0,93.88,28.31,112.31,75.74L250,138l.47-1.2C268.9,89.4,310.89,61.09,362.78,61.09c33,0,61,12.4,80.93,35.86,18.75,22.06,29.07,53,29.07,87C472.78,268.15,404.07,344.93,250,432.84Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.78,61.59c32.86,0,60.71,12.34,80.55,35.68,18.67,22,28.95,52.75,28.95,86.66,0,43.44-18.54,84.72-56.69,126.2-36,39.11-90.15,79.07-165.59,122.13-75.44-43.06-129.61-83-165.59-122.13-38.15-41.48-56.69-82.76-56.69-126.2,0-34.07,10.13-64.84,28.53-86.66,19.68-23.34,47.68-35.68,81-35.68,27.18,0,51.14,7.37,71.21,21.89,18,13.07,32.1,31.58,40.64,53.53l.93,2.4.93-2.4c8.54-21.95,22.59-40.46,40.64-53.53,20.07-14.52,44-21.89,71.21-21.89m0-1c-57.61,0-96.25,33.54-112.78,76.06-16.53-42.52-55.17-76.06-112.78-76.06-70.63,0-110.5,55-110.5,123.34,0,88.85,77.46,166.32,223.28,249.48,145.82-83.16,223.28-160.63,223.28-249.48,0-68.36-41-123.34-110.5-123.34Z"
}));

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.088e1832.svg";
export { ForwardRef as ReactComponent };